import CloseIcon from "@mui/icons-material/Close";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { type FC, type PropsWithChildren, useId } from "react";

import * as Styled from "./ChartDialog.styles";

interface IChartDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
}

export const ChartDialog: FC<PropsWithChildren<IChartDialogProps>> = ({
  open,
  onClose,
  title,
  subtitle,
  children,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const titleId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="md"
      aria-labelledby={titleId}
    >
      <Styled.Header>
        <Styled.Heading>
          <Styled.Title id={titleId} component="h2" variant="subtitle1">
            {title}
          </Styled.Title>
          <Styled.Subtitle variant="caption">{subtitle}</Styled.Subtitle>
        </Styled.Heading>
        <Styled.CloseButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </Styled.CloseButton>
      </Styled.Header>
      {children}
    </Dialog>
  );
};
